export default __webpack_public_path__ + "static/icon-22-5-f2053e769844074a074646b91c45f365.png";